// --- utilities -------------------------------------------------------------

function extractColumnMeta(col: any) {
    const def = col?.columnDef;
    const meta = def?.meta ?? {};

    return {
        metaFilter: meta.filterName as string | string[] | undefined,
        metaFilterStart: meta.filterNameStart as string | undefined,
        metaFilterEnd: meta.filterNameEnd as string | undefined,
        metaField: meta.fieldName as string | undefined,
        accessorKey: def?.accessorKey as string | undefined
    };
}

function buildFilters(table: any, columnFilters: any[], globalFilter: any) {
    const filters: Record<string, string> = {};

    for (const cf of columnFilters) {
        const col = table.getColumn(String(cf.id));
        const {
            metaFilter, metaFilterStart, metaFilterEnd, accessorKey
        } =
      extractColumnMeta(col);

        const { value } = cf;
        const fieldId = String(cf.id);

        // --- handle date range filters ---------------------------------------
        if (value && typeof value === 'object') {
            const startValue = value.from ?? value.start;
            const endValue = value.to ?? value.end;

            if (startValue || endValue) {
                const startKey =
          metaFilterStart ??
          (Array.isArray(metaFilter) ? metaFilter[0] : undefined) ??
          accessorKey ??
          `${fieldId}_start`;

                const endKey =
          metaFilterEnd ??
          (Array.isArray(metaFilter) ? metaFilter[1] : undefined) ??
          accessorKey ??
          `${fieldId}_end`;

                if (startValue) filters[startKey] = String(startValue).trim();
                if (endValue) filters[endKey] = String(endValue).trim();

                continue;
            }
        }

        // --- fallback: single value filter -----------------------------------
        if (value != null) {
            const fieldName =
        typeof metaFilter === 'string' ? metaFilter : accessorKey ?? fieldId;

            const trimmed = String(value).trim();
            if (trimmed) filters[fieldName] = trimmed;
        }
    }

    // Always include so server tables can clear lookup when the search box is emptied.
    filters.search = String(globalFilter ?? '').trim();

    return filters;
}

function buildOrdering(table: any, sorting: any[]) {
    if (!sorting?.length) return '';

    return sorting
        .map((s) => {
            const col = table.getColumn(String(s.id));
            const { metaFilter, metaField, accessorKey } = extractColumnMeta(col);

            const fieldName = metaFilter ?? metaField ?? accessorKey ?? s.id;

            return `${s.desc ? '-' : ''}${fieldName}`;
        })
        .join(',');
}

export {
    buildFilters,
    buildOrdering
};
